import ColorContraste from "../colores/colorContraste";
import TypesUtils from "../../utils/typesUtils";

class Escala {
    constructor(escalaValores, escalaColor, escalaColorContraste) {
        this.escalaValores = escalaValores;
        this.escalaColor = escalaColor;
        this.escalaColorContraste = escalaColorContraste;

        if (
            this.escalaValores.length !== this.escalaColor.length ||
            this.escalaValores.length !== this.escalaColorContraste.length
        ) {
            throw new Error(
                "[Escala] Arrays de creacion de escala inválidos. Sus tamaños no son iguales"
            );
        }
    }

    getColCon(valor) {
        if (TypesUtils.isStr(valor)) {
            return new ColorContraste(
                this.escalaColor[0],
                this.escalaColorContraste[0]
            );
        }
        for (var i = 0; i < this.escalaValores.length; i++) {
            if (valor < this.escalaValores[i])
                return new ColorContraste(
                    this.escalaColor[i],
                    this.escalaColorContraste[i]
                );
        }
        return new ColorContraste(
            this.escalaColor[this.escalaColor.length - 1],
            this.escalaColorContraste[this.escalaColorContraste.length - 1]
        );
    }
}

class Escalas {
    constructor() {
        this.escalas = {};
    }

    add(id, escala) {
        this.escalas[id] = escala;
    }

    get(id) {
        return this.escalas[id];
    }
}

export { Escala, Escalas };
